export default class hover {
    constructor(manager,scene) {

        //manager
        this.manager = manager;
        this.sceneManager = scene;

    }
    init(){

        if(Useragnt.pc){
            // ボタンのhover動作
            for(let i in this.sceneManager.$scrollList){
                if(this.sceneManager.$scrollList[i].nodeType!=1) continue; // dom要素以外は処理止める
                this.sceneManager.$scrollList[i].addEventListener("mouseenter",()=>{
                    this.enter(i);
                })
                this.sceneManager.$scrollList[i].addEventListener("mouseleave",()=>{
                    this.leave(i);
                })
            }
        }

    }
    enter(index){

        for(let i in this.sceneManager.$scrollList) {
            if (this.sceneManager.$scrollList[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i == index){
                TweenMax.to(this.sceneManager.$scrollList[i].querySelector('.image'), 2.2 ,{
                    scale:1.04,
                    ease: Power2.easeOut,
                });
            }else{
                TweenMax.to(this.sceneManager.$scrollList[i], .6 ,{
                    opacity:.4,
                    ease: Power2.easeOut,
                });
            }
        }

    }
    leave(index){

        for(let i in this.sceneManager.$scrollList) {
            if (this.sceneManager.$scrollList[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i == index){
                TweenMax.to(this.sceneManager.$scrollList[i].querySelector('.image'), 1.4 ,{
                    scale:1,
                });
            }else{
                TweenMax.to(this.sceneManager.$scrollList[i], .6 ,{
                    opacity:1,
                    ease: Power2.easeOut,
                });
            }
        }

    }
}